import React from 'react'
import { Router } from 'react-static'
import { hot } from 'react-hot-loader'
import Routes from 'react-static-routes'
import { Provider } from 'react-redux'
import store from './connectors/redux'

import Wrapper from './Wrapper'
import { Footer } from './includes/'

import './static/scss/core.scss'


const App = () => (
  <Provider store={store} >
    <Router>
        <Wrapper>
          <div className="content">
            <Routes />
          </div>
        </Wrapper>
        <Footer />
    </Router>
  </Provider>
)

export default hot(module)(App)



// WEBPACK FOOTER //
// /Users/kentorry/Server/CLIENT-SERVER/CLIENT-WORK/afrodesiamedia/SERVER/afrodesiamedia/src/App.js